import { CHART_GRID_COLOR } from '@/components/Chart/hooks/options/useChartFunctions';
import { Z_INDEX } from '@/constants/z-index';

import type { Theme } from '@mui/material';
import type Highcharts from 'highcharts/highstock';

const getRegularTooltip = (
  createTooltipFormatter: (
    allChartSeries: Highcharts.Series[],
    hoveredPointXValue: string | number | undefined
  ) => string,
  theme: Theme
) => {
  const tooltip: Highcharts.TooltipOptions = {
    positioner(labelWidth, labelHeight, point) {
      const chart = this.chart;
      let x = point.plotX + chart.plotLeft - labelWidth / 2;
      let y = point.plotY + chart.plotTop - labelHeight - 10;

      const chartWidth = chart.plotWidth;

      if (x < chart.plotLeft) {
        x = chart.plotLeft;
      } else if (x + labelWidth > chart.plotLeft + chartWidth) {
        x = chart.plotLeft + chartWidth - labelWidth;
      }

      if (y < chart.plotTop) {
        y = point.plotY + chart.plotTop + 10;
      }

      return { x, y };
    },
    formatter(): string {
      const allChartSeries = this.series.chart.series;
      const hoveredPointXValue = this.x;
      return createTooltipFormatter(allChartSeries, Number(hoveredPointXValue));
    },
    outside: true,
    className: 'tooltip-regular-chart',
    enabled: true,
    split: false,
    followPointer: true,
    backgroundColor: CHART_GRID_COLOR,
    borderRadius: 0,
    useHTML: true,
    style: {
      zIndex: Z_INDEX.chartOverlay,
      color: theme.palette.text.primary,
      fontFamily: 'Cairo, sans-serif'
    }
  };

  return { tooltip };
};

export default getRegularTooltip;
